<pr-form
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  <pr-tabs clazz="drawer-tab-button" [defaultTextColor]="false">
    <pr-tab label="Informations générales">
      <div class="grid grid-col-2 grid-col-sm-1">
        <pr-input-autosuggest
          formControlName="providerId"
          label="Assureur"
          optionLabel="name"
          optionValue="id"
          [options]="providers"
          [onCreateOption]="createProviderFn"
          [derrors]="derrors"
        ></pr-input-autosuggest>

        <pr-input-autosuggest
          formControlName="productId"
          label="Produit"
          optionLabel="name"
          optionValue="id"
          [options]="filteredProducts"
          [onCreateOption]="selectedProviderId ? createProductFn : null"
          [derrors]="derrors"
        ></pr-input-autosuggest>

        <pr-input label="Numéro de contrat" [derrors]="derrors">
          <input formControlName="numeroContrat" type="text" />
        </pr-input>

        <pr-input-date
          formControlName="dateSouscription"
          label="Date de début de couverture"
          [derrors]="derrors"
        ></pr-input-date>

        <pr-input label="Cotisation" suffix="€" [derrors]="derrors">
          <input formControlName="cotisation" type="number" />
        </pr-input>

        @if (!isAE) {
          <pr-input label="Périodicité de cotisation" [derrors]="derrors">
            <mat-select formControlName="cotisationPeriode">
              <mat-option value="MENSUEL">Mensuelle</mat-option>
              <mat-option value="ANNUEL">Annuelle</mat-option>
            </mat-select>
          </pr-input>
        }

        <pr-input label="Titulaire" [derrors]="derrors">
          <mat-select formControlName="ownerId">
            @for (user of users; track user) {
              <mat-option [value]="user.id">
                {{ user.label }}
              </mat-option>
            }
          </mat-select>
        </pr-input>
      </div>

      <div class="file-upload-section">
        <label class="file-upload-label">Documents <span class="required-star">*</span></label>
        @for (file of visibleExistingFiles; track file.gedDocumentId + '-' + file.fileIndex) {
          <div class="file-item existing">
            <span class="fs-14 pointer text-accent" (click)="viewExistingFile(file)">{{ file.fileName }}</span>
            <pr-icon
              class="pointer text-danger"
              name="close"
              [width]="16"
              (click)="markExistingFileForDeletion(file)"
            ></pr-icon>
          </div>
        }
        @for (file of files; track file.name; let i = $index) {
          <div class="file-item">
            <span class="fs-14">{{ file.name }}</span>
            <pr-icon
              class="pointer text-danger"
              name="close"
              [width]="16"
              (click)="removeFile(i)"
            ></pr-icon>
          </div>
        }
        <label class="file-upload-btn">
          <input
            type="file"
            multiple
            accept=".pdf,.jpeg,.jpg,.png"
            (change)="onFileSelected($event)"
            hidden
          />
          <span class="text-accent fw-500 pointer">+ Ajouter un fichier</span>
        </label>
        @if (filesError) {
          <p class="text-danger fs-12 mts">{{ filesError }}</p>
        }
        <p class="text-secondary fs-12">Formats autorisés : pdf, jpeg, png</p>
      </div>
    </pr-tab>

    <pr-tab label="Détails du contrat">
        @if (isPrevoyance) {
          <div class="grid grid-col-2 grid-col-sm-1">
            <p class="fw-600 fs-16 mbl full-width">Incapacité temporaire totale (ITT)</p>
            <pr-input label="Montant mensuel" suffix="€/mois">
              <input formControlName="ittMontantMensuel" type="number" />
            </pr-input>
            <pr-input label="Frais généraux mensuels" suffix="€/mois">
              <input formControlName="ittFraisGenerauxMensuels" type="number" [attr.placeholder]="fraisGenerauxPlaceholder" />
            </pr-input>
            <pr-input label="Franchises">
              <input formControlName="ittFranchises" type="text" />
            </pr-input>
            <pr-input label="Renfort dos">
              <mat-select formControlName="ittRenfortDos">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
            </pr-input>
            <pr-input label="Affection psy">
              <mat-select formControlName="ittAffectionPsy">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
            </pr-input>
            <pr-input label="Délais d'attente">
              <input formControlName="ittDelaisAttente" type="text" />
            </pr-input>
            <pr-input label="Mi-temps thérapeutique">
              <mat-select formControlName="ittMiTempsTherapeutique">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Invalidité</p>
            <pr-input label="Montant mensuel" suffix="€/mois">
              <input formControlName="invaliditeMontantMensuel" type="number" />
            </pr-input>
            <pr-input label="Barème d'invalidité">
              <mat-select formControlName="invaliditeBareme">
                @for (bareme of baremeInvaliditeRef; track bareme) {
                  <mat-option [value]="bareme.id">{{ bareme.value }}</mat-option>
                }
              </mat-select>
            </pr-input>
            <pr-input label="Seuil de déclenchement" suffix="%">
              <input formControlName="invaliditeSeuilDeclenchement" type="number" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Décès / PTIA</p>
            <pr-input label="Montant" suffix="€">
              <input formControlName="decesPtiaMontant" type="number" [attr.placeholder]="decesPtiaPlaceholder" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Cotisations</p>
            <pr-input label="Cotisation mensuelle">
              <input formControlName="cotisationMensuelle" type="text" />
            </pr-input>
            <pr-input label="Cotisation Madelin">
              <input formControlName="cotisationMadelin" type="text" />
            </pr-input>
          </div>
        }

        @if (isAE) {
          <div class="grid grid-col-2 grid-col-sm-1">
            <p class="fw-600 fs-16 mbl full-width">Quotités</p>
            <pr-input label="Décès" suffix="%">
              <input formControlName="quotiteDeces" type="number" />
            </pr-input>
            <pr-input label="PTIA" suffix="%">
              <input formControlName="quotitePtia" type="number" />
            </pr-input>
            <pr-input label="IPT" suffix="%">
              <input formControlName="quotiteIpt" type="number" />
            </pr-input>
            <pr-input label="ITT" suffix="%">
              <input formControlName="quotiteItt" type="number" />
            </pr-input>
            <pr-input label="IPP" suffix="%">
              <input formControlName="quotiteIpp" type="number" />
            </pr-input>
            <pr-input label="PE" suffix="%">
              <input formControlName="quotitePe" type="number" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Garanties</p>
            <pr-input label="Franchise ITT" suffix="jours">
              <input formControlName="franchiseIttJours" type="number" />
            </pr-input>
            <pr-input label="Franchise PE" suffix="jours">
              <input formControlName="franchisePeJours" type="number" />
            </pr-input>
            <pr-input label="Type d'indemnisation">
              <mat-select formControlName="typeIndemnisation">
                <mat-option value="FORFAITAIRE">Forfaitaire</mat-option>
                <mat-option value="INDEMNITAIRE">Indemnitaire</mat-option>
              </mat-select>
            </pr-input>
            <pr-input label="Prise en charge dos/psy">
              <mat-select formControlName="priseEnChargeDosPsy">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
            </pr-input>
          </div>
        }

        @if (isMutuelle) {
          <div class="grid grid-col-2 grid-col-sm-1">
            <p class="fw-600 fs-16 mbl full-width">Hospitalisation</p>
            <pr-input label="Honoraires Optam" suffix="%">
              <input formControlName="hospitalisationHonorairesOptam" type="number" />
            </pr-input>
            <pr-input label="Honoraires Non Optam" suffix="%">
              <input formControlName="hospitalisationHonorairesNonOptam" type="number" />
            </pr-input>
            <pr-input label="Chambre particulière" suffix="€">
              <input formControlName="hospitalisationChambreParticuliere" type="number" />
            </pr-input>
            <pr-input label="Prime maternité">
              <input formControlName="hospitalisationPrimeMaternite" type="text" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Optique</p>
            <pr-input label="Lunettes (verres + monture)" suffix="€/an">
              <input formControlName="optiqueLunettes" type="number" />
            </pr-input>
            <pr-input label="Lentilles" suffix="€/an">
              <input formControlName="optiqueLentilles" type="number" />
            </pr-input>
            <pr-input label="Plafond optique" suffix="€/an">
              <input formControlName="optiquePlafond" type="number" />
            </pr-input>
            <pr-input label="Chirurgie Laser" suffix="€">
              <input formControlName="optiqueChirurgieLaser" type="number" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Dentaire</p>
            <pr-input label="Prothèse" suffix="%">
              <input formControlName="dentaireProthese" type="number" />
            </pr-input>
            <pr-input label="Orthodontie adulte">
              <input formControlName="dentaireOrthodontieAdulte" type="text" />
            </pr-input>
            <pr-input label="Orthodontie enfant">
              <input formControlName="dentaireOrthodontieEnfant" type="text" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Pharmacie</p>
            <pr-input label="Prise en charge" suffix="%">
              <input formControlName="pharmaciePriseEnCharge" type="number" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Médecines douces</p>
            <pr-input label="Médecines douces">
              <input formControlName="medecinesDouces" type="text" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Consultations</p>
            <pr-input label="Optam/CAS" suffix="%">
              <input formControlName="consultationsOptamCas" type="number" />
            </pr-input>
            <pr-input label="Non Optam/Non CAS" suffix="%">
              <input formControlName="consultationsNonOptamNonCas" type="number" />
            </pr-input>

            <p class="fw-600 fs-16 mbl mtl full-width">Cotisations</p>
            <pr-input label="Montant" suffix="€">
              <input formControlName="cotisationsMontant" type="number" />
            </pr-input>
          </div>
        }

        <p class="fw-600 fs-16 mbl mtl">Commentaire</p>
        <pr-input label="Commentaire">
          <textarea formControlName="commentaire" rows="3"></textarea>
        </pr-input>
      </pr-tab>
  </pr-tabs>
</pr-form>
